import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBigCutlery = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 38,
	viewBox: "0 0 28 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.98675 37.3337V20.4976C4.40806 20.1309 3.07126 19.311 1.97633 18.0378C0.881433 16.7647 0.333984 15.2522 0.333984 13.5003V0.666992H3.38951V13.5003H5.98675V0.666992H9.04232V13.5003H11.6396V0.666992H14.6951V13.5003C14.6951 15.2522 14.1476 16.7647 13.0527 18.0378C11.9578 19.311 10.621 20.1309 9.04232 20.4976V37.3337H5.98675ZM24.7785 37.3337V22.667H19.4312V9.06976C19.4312 6.61514 20.218 4.60102 21.7916 3.02741C23.3652 1.4538 25.3794 0.666992 27.834 0.666992V37.3337H24.7785Z",
		fill: "#393A36"
	})
});
export default SvgBigCutlery;
